import React, { Component } from 'react';
import { connect } from 'react-redux';
import { placeOrder, getZipcode } from '../../../store/actions/user/User';
import { Link } from 'react-router-dom';
import { Redirect, withRouter } from 'react-router-dom';
import { Button, Modal, ModalBody } from 'reactstrap';

class Checkout extends Component {
  constructor(props) {
    super(props);

    this.goToHome = this.goToHome.bind(this);
    this.toggleZip = this.toggleZip.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  state = {
    addressOption: null,
    address: '',
    addressL2: '',
    country: '',
    phone: '',
    ZipCode: '',
    zipCodeNotAvailable: false,
    tip: 0,
    total: localStorage.getItem('totalCost'),
    mode: ''
  };

  toggleZip() {
    this.setState({ zipCodeNotAvailable: !this.state.zipCodeNotAvailable });
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleAddTip = (e) => {
    e.preventDefault();
    let total = +this.state.tip + +this.state.total;
    this.setState({ ...this.state, tip: this.state.tip, total: total });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    var validZipCode = this.props.zipcodes.filter(
      (zip) => zip.name === this.state.ZipCode
    );
    if (!validZipCode.length) {
      this.setState({ zipCodeNotAvailable: !this.state.zipCodeNotAvailable });
    } else {
      //add userid, vendorId, productId, totalAmt, discount, grandTotal, tip, status:null
      const address = {
        addressL1: this.state.address,
        addressL2: this.state.addressL2,
        country: this.state.country,
        phone: this.state.phone,
        zipCode: this.state.ZipCode
      };
      const order = {
        email: localStorage.getItem('email'),
        userId: localStorage.getItem('uid'),
        products: this.props.cart,
        subTotal: +localStorage.getItem('cost'),
        discount: +localStorage.getItem('promoCost'),
        grandTotal: +localStorage.getItem('totalCost'),
        tip: +this.state.tip,
        finalTotal: +this.state.total,
        address: address,
        paymentMode: 'COD',
        status: 'pending',
        date: new Date(),
        timestamp: new Date().getTime()
      };

      this.props.placeOrder(order);
      setTimeout(() => {
        this.props.history.push('/cart');
      }, 2000);
    }
  };

  handleShipping = (e) => {
    this.setState({ deliveryType: e.target.value });
  };

  onChangeValue = (e) => {
    // const addressOption = 'addressOption'
    this.setState({
      addressOption: e.target.value
    });
  };

  componentDidMount() {
    this.props.getZipcode();
  }

  goToHome() {
    this.props.history.push('/');
  }
  render() {
    if (!localStorage.getItem('city')) return <Redirect to="/" />;

    // if (this.state.isLoading) return <Loader/>
    const cart = localStorage.getItem('cart')
      ? JSON.parse(localStorage.getItem('cart'))
      : [];
    return (
      <div>
        <Modal isOpen={this.state.zipCodeNotAvailable} centered="true">
          <ModalBody>
            <h3>
              Sorry
              <br />
              We are not delivering at you zipcode for the moment
            </h3>
            <br />
            <Button
              color="danger"
              style={{ width: '100%' }}
              onClick={this.toggleZip}
            >
              Ok
            </Button>
          </ModalBody>
        </Modal>
        {/* <div class="modal fade" id="orderPlaced"  data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <h2>Your order is placed</h2>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" onClick={this.goToHome}>Ok</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="zipCodeNotAvailable" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <h2>Sorry<br/>We are not delivering to that area for the moment</h2>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" >Change the zipCode</button>
              </div>
            </div>
          </div>
        </div> */}

        <div className="page-top-info">
          <div className="container">
            <h4>Checkout</h4>
            <div className="site-pagination">
              <Link to="/">Home</Link>
              <Link to="/cart">Checkout</Link>
            </div>
          </div>
        </div>
        <section className="checkout-section spad">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 order-2 order-lg-1">
                <form className="checkout-form" onSubmit={this.handleSubmit}>
                  <h2>Billing Address</h2>
                  <div className="row address-inputs">
                    <div className="col-md-12">
                      <input
                        type="text"
                        placeholder="Address"
                        id="address"
                        onChange={this.handleChange}
                      />
                      <input
                        type="text"
                        placeholder="Address line 2"
                        id="addressL2"
                        onChange={this.handleChange}
                      />
                      <input
                        type="text"
                        placeholder="Country"
                        id="c  ountry"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        placeholder="Zip code"
                        id="ZipCode"
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        placeholder="Phone no."
                        id="phone"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="radio"
                        id="mode"
                        name="mode"
                        required
                        onChange={this.handleChange}
                        value="COD"
                      />
                      <label>COD</label>
                    </div>
                    <div className="col-md-6">
                      <input
                        type="radio"
                        id="mode"
                        name="mode"
                        required
                        onChange={this.handleChange}
                        value="Prepaid"
                      />
                      <label>Prepaid</label>
                    </div>
                  </div>
                  <button className="site-btn submit-order-btn" type="submit">
                    Place Order
                  </button>
                </form>
                <br />
                <br />
                <button
                  type="button"
                  class=" site-btn submit-order-btn"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  Add a Tip
                </button>
                <div
                  class="modal fade"
                  id="exampleModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                          Add a tip
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <form>
                          <div class="form-group">
                            <label for="tip">Tip Amount</label>
                            <input
                              type="number"
                              class="form-control"
                              id="tip"
                              onChange={this.handleChange}
                            />
                            <small id="emailHelp" class="form-text text-muted">
                              Small gestures lead big ways
                            </small>
                          </div>
                          <button
                            class="btn btn-primary"
                            data-dismiss="modal"
                            onClick={this.handleAddTip}
                          >
                            Add Tip
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 order-1 order-lg-2">
                <div className="cart-table">
                  <h3>Your Cart</h3>
                  <div
                    className="cart-table-warp"
                    style={{ overflow: 'scroll' }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th className="product-th">Product</th>
                          <th className="quy-th">Quantity</th>
                          <th className="total-th">Price</th>
                          {/* <th className="size-th">Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {cart.map((item) => (
                          <tr>
                            <td className="product-col">
                              <img src="img/cart/1.jpeg" alt="" />
                              <div className="pc-title">
                                <h4>
                                  {item.quantity} X {item.name}
                                </h4>
                                <p>${item.price}</p>
                              </div>
                            </td>
                            <td className="size-col">
                              <div className="quantity">
                                <div
                                  className="pro-qty"
                                  style={{
                                    width: '30px',
                                    'border-radius': '0',
                                    height: '29px',
                                    'text-align': 'center',
                                    padding: '0'
                                  }}
                                >
                                  <input type="text" value={item.quantity} />
                                </div>
                              </div>
                            </td>
                            <td className="total-col">
                              <h4>${item.quantity * item.price[0]}</h4>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {cart.length ? (
                    <div className="total-cost">
                      <h6>
                        SubTotal <span> ${localStorage.getItem('cost')} </span>
                      </h6>
                      {localStorage.getItem('promoCost') ? (
                        <h6>
                          Promo Code
                          <span>-${localStorage.getItem('promoCost')}</span>
                        </h6>
                      ) : (
                        <></>
                      )}
                      {this.state.tip !== 0 ? (
                        <h6>
                          Tip<span>+${this.state.tip}</span>
                        </h6>
                      ) : (
                        <></>
                      )}
                      <h6>
                        Total <span>${this.state.price}</span>
                      </h6>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.user.cart,
  zipcodes: state.user.zipcode
});

const mapDispatchToProps = (dispatch) => ({
  placeOrder: (order) => dispatch(placeOrder(order)),
  getZipcode: () => dispatch(getZipcode())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Checkout)
);
